import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconShapeSocialStory = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <rect
        x="4.25"
        y="0.75"
        width="7.5"
        height="14.5"
        rx="1.25"
        stroke="#626266"
        strokeWidth="1.5"
      />
    </SvgIcon>
  ))
);
IconShapeSocialStory.displayName = 'IconShapeSocialStory';
